import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';
import type EmployeeModel from './employee.ts';
import type TASProgramInstanceModel from './tas-program-instance.ts';
import type PersonModel from './person.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class DependentModel extends Model {
  @attr declare birthDate: string;
  @attr declare email: string;
  @attr declare firstName: string;
  @attr declare lastName: string;
  @attr declare relationship: string;
  @attr declare flavor: string;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;
  @attr declare deletedAt: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('employee', { async: false, inverse: null })
  declare employee: EmployeeModel;
  @belongsTo('person', { async: false, inverse: null })
  declare person: PersonModel;
  @hasMany('tas-program-instance', { async: false, inverse: 'dependent' })
  declare tasProgramInstances: TASProgramInstanceModel[];

  /**************************
   **  Computed Properties **
   **************************/

  get enrolledDate() {
    const activeLogin = this.person?.user?.logins?.find((l) => l.isActive);
    return activeLogin?.createdAt;
  }

  get fullName() {
    return [this.firstName, this.lastName].join(' ');
  }

  get notDeleted() {
    return this.deletedAt === null;
  }

  get relationshipLabel() {
    // Handle both "CHILD" and "DependentRelationship.CHILD" formats
    const relationship = this.relationship?.split('.').pop() || '';
    const relationshipMap: Record<string, string> = {
      CHILD: 'Child',
      PARTNER: 'Partner',
      SPOUSE: 'Spouse',
    };
    return relationshipMap[relationship] || this.relationship;
  }

  [Type] = 'dependent' as const;
}
